module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content cleafix"
  }, [_c('form', [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("\n                重置密码\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "tabindex": "-1",
      "type": "text",
      "name": "username",
      "placeholder": "请输入邮箱、手机号",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": [function($event) {
        _vm.checkUsername()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.username))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "tabindex": "-1",
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 n-p-r n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "disabled": _vm.reset.disabled
    },
    on: {
      "click": function($event) {
        _vm.resendEmailCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.reset.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "tabindex": "-1",
      "type": "password",
      "name": "password",
      "placeholder": "请输入密码",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rpassword),
      expression: "rpassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "tabindex": "-1",
      "type": "password",
      "name": "rpassword",
      "placeholder": "请再次输入密码",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpassword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.password))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "tabindex": "-1",
      "type": "button",
      "value": "重置密码"
    },
    on: {
      "click": function($event) {
        _vm.registerFunc()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('h5', {
    staticClass: "reg_now"
  }, [_vm._v("还没有帐号？\n                        "), _c('router-link', {
    attrs: {
      "to": {
        name: '/auth/register',
        params: {}
      }
    }
  }, [_vm._v("马上注册")]), _vm._v(" "), _c('router-link', {
    staticClass: "right",
    attrs: {
      "to": {
        name: '/auth/login',
        params: {}
      }
    }
  }, [_vm._v("直接登录")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379e986e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/reset-password.vue
// module id = 475
// module chunks = 1